import { Eventcalendar } from "@mobiscroll/react";
import { styled } from "@mui/material";

const StyledCalendar = styled(Eventcalendar)`
  & {
    flexGrow: 1;
    height: 100%;
    overflow: visible;
    width: 100%;

    .ghost-event {
      transition: 300ms ease-in-out;
      opacity: 0;
      pointer-events: none;
    }

    .ghost-event.hover {
      opacity: 0.4;
    }
    
    .ghost-event.visible {
      opacity: 0.4;
    }

    .mbsc-calendar-wrapper.mbsc-ios {
      margin: 0;
      padding: 0 !important;
    }

    .mbsc-timeline-header-date-text {
      display: none;
    }

    .mbsc-calendar-header {
      display: none;
    }

    div.mbsc-calendar-week-days {
      background: white;
      div.mbsc-calendar-week-day {
        text-align: center;
      }
    }

    .mbsc-timeline-day .mbsc-timeline-header-date {
      border: none;
    }

    .mbsc-timeline-day .mbsc-timeline-header-date-cont {
      display: none;
    }

    .mbsc-custom-provider-type-header {
      background: white;
    }

    /*
     * Mobiscroll's base 'collapse' functionality isn't sticky, and it swallows the click event.
     * We provide our own version of this button.
     */
    .mbsc-custom-provider-type-header > .mbsc-timeline-resource-icon {
      display: none;
    }

    .mbsc-custom-provider-type-header .mbsc-timeline-day .mbsc-timeline-column {
      background: white;
      border: none;
    }

    .mbsc-timeline-header-text {
      margin-left: auto;
    }

    .mbsc-ios.mbsc-calendar-header,
    .mbsc-ios.mbsc-calendar-day:after,
    .mbsc-calendar-cell {
      border-color: rgba(19, 34, 149, 0.1);
      background: white !important;
    }

    .mbsc-calendar-text.mbsc-ltr {
      margin-bottom: ${(props) => props.eventMarginBottom || "inherit"};
    }

    .mbsc-timeline-resource.mbsc-ios.mbsc-ltr {
      min-height: ${(props) => props.timelineResourceMinHeight || "inherit"};
      display: flex;
      align-items: center;
      padding-left: 0 !important;
    }

    /* Keep the first (resource) column at least 205px */
    .mbsc-timeline-resource-header-cont,
    .mbsc-timeline-resource-footer-cont,
    .mbsc-timeline-resources,
    .mbsc-timeline-resource,
    .mbsc-timeline-resource-empty,
    .mbsc-timeline-resource-group {
      min-width: 235px;
    }

    .mbsc-timeline-resource-title {
      min-width: 100%;
    }

    .mbsc-timeline-column,
    .mbsc-timeline-header-column {
      width: 200px;
      min-width: 200px;
      align-items: center;
    }

    .mbsc-timeline-column::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 0.65em;
      width: 100%;
      background-color: white;
      z-index: 1;
    }

    .mbsc-ios.mbsc-schedule-all-day-item:after,
    .mbsc-ios.mbsc-schedule-column,
    .mbsc-ios.mbsc-schedule-item,
    .mbsc-ios.mbsc-schedule-resource,
    .mbsc-ios.mbsc-schedule-resource-group,
    .mbsc-ios.mbsc-timeline-column,
    .mbsc-ios.mbsc-timeline-day:after,
    .mbsc-ios.mbsc-timeline-header,
    .mbsc-ios.mbsc-timeline-header-column,
    .mbsc-ios.mbsc-timeline-header-date,
    .mbsc-ios.mbsc-timeline-header-month,
    .mbsc-ios.mbsc-timeline-header-week,
    .mbsc-ios.mbsc-timeline-resource,
    .mbsc-ios.mbsc-timeline-resource-empty,
    .mbsc-ios.mbsc-timeline-slot-header,
    .mbsc-ios.mbsc-timeline-slots {
      border-color: rgba(19, 34, 149, 0.1);
    }

    .mbsc-timeline-header-time {
      text-align: center;
      font-size: 12px;
    }

    .mbsc-ios.mbsc-calendar-header,
    .mbsc-ios.mbsc-calendar-wrapper {
      border-color: rgba(255, 34, 149, 0.1);
      padding-bottom: 5px;
    }

    .mbsc-ios.mbsc-eventcalendar .mbsc-calendar-wrapper {
      border-color: rgba(19, 34, 149, 0.1);
      padding-bottom: 8px;
    }

    .mbsc-ios.mbsc-schedule-time-indicator {
      border-color: #3D1F47;
    }
    .mbsc-schedule-time-indicator-y {
      border-left: 3px solid;
    }

    .mbsc-timeline {
      z-index: 0;
    }

    .md-timeline-template .mbsc-schedule-event.mbsc-ltr {
      height: auto !important;
    }

    .mbsc-timeline-event {
      cursor: default;
    }
    .mbsc-timeline-event > div {
      cursor: pointer;
    }

    .md-timeline-template-event {
      border: 1px solid transparent;
      margin: 2px 0;
    }

    .md-timeline-template-event-cont {
      background: rgba(255, 255, 255, 0);
      font-size: 15px;
      height: 44px;
      padding-left: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .md-timeline-template-event-cont .mbsc-icon {
      padding: 5px;
      box-sizing: content-box;
    }

    .md-before-buffer {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .mbsc-timeline-event-start .md-timeline-template-event,
    .mbsc-timeline-event-start .md-timeline-template-event-cont,
    .mbsc-timeline-event-start .md-timeline-template-event-cont .mbsc-icon {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .md-after-buffer {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .mbsc-timeline-event-end .md-timeline-template-event,
    .mbsc-timeline-event-end .md-timeline-template-event-cont,
    .mbsc-timeline-event-end .md-timeline-template-event-cont .mbsc-icon {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .md-buffer {
      position: absolute;
      display: flex;
      width: 100%;
      font-size: 10px;
      top: 2px;
      bottom: 2px;
      left: 0;
      color: #fff;
      padding: 0 6px;
      line-height: 12px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      //opacity: 1;
      box-sizing: border-box;
      z-index: -1;
    }

    .md-buffer-tail {
      position: absolute;
      width: 14px;
      height: 100%;
      top: 0;
    }

    .md-before-buffer .md-buffer-tail {
      left: 100%;
    }

    .md-after-buffer .md-buffer-tail {
      right: 100%;
    }

    .md-buffer-time {
      font-weight: 600;
    }

    .md-before-buffer.type-calendar_block_filter {
      margin-left: -0.25em;
      margin-bottom: -2px;
      margin-top: -2px;
    }

    .md-after-buffer.type-calendar_block_filter {
      margin-left: 0.25em;
      margin-bottom: -2px;
      margin-top: -2px;
    }

    .md-timeline-template-event-cont .mbsc-icon:before {
      color: #fff;
      font-size: 18px;
    }

    .md-timeline-template-time {
      margin: 0 10px;
    }

    .md-timeline-template-title {
      color: #666;
    }

    .md-timeline-template .mbsc-timeline-column,
    .md-timeline-template .mbsc-timeline-header-column {
      min-width: 100px;
    }

    .md-timeline-template .mbsc-timeline-resource,
    .md-timeline-template .mbsc-timeline-row {
      min-height: 100px;
    }

    .mbsc-timeline-row {
      height: 90px;
    }

    .mbsc-timeline-parent { height: 40px; }

    .blink {
      animation: blink-animation 1s ease-in-out infinite;
      -webkit-animation: blink-animation 1s ease-in-out infinite;
    }

    @keyframes blink-animation {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
    }

    @-webkit-keyframes blink-animation {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
    }

    .invalid-drop {
      background: repeating-linear-gradient(-45deg, rgb(243, 243, 243), rgb(243, 243, 243) 11px, rgb(229, 229, 229) 11px, rgb(229, 229, 229) 22px);
      z-index: 2;
      opacity: 0.5;
    }

    .inactive-provider {
      background: rgba(0, 0, 0, 0.08);
    }

    .dashed-connection {
      stroke-dasharray: 5;
      opacity: 0;
      transition: 200ms ease-in-out;
    }

    /*
     * The "hover" class is added by the VisitEvent component; the connection element is distant in the DOM from
     * the visit resources, making it easier to maintain the connection between them via JS rather than CSS.
     */
    .dashed-connection.hover, .dashed-connection.hover+.mbsc-connection-arrow {
      opacity: 1;
      transition: 200ms ease-in-out;
    }

    .connection-arrow {
      stroke-dasharray: none;
    }

    .mbsc-connections {
      z-index: 3;
    }
    .dashed-border .md-timeline-template-event{
      border-width: 2px !important;
      border-style: dashed !important;
    }

  }
`;


export default StyledCalendar;
